import { render, staticRenderFns } from "./MensagemAlerta.vue?vue&type=template&id=740e6f73&scoped=true"
import script from "./MensagemAlerta.vue?vue&type=script&lang=js"
export * from "./MensagemAlerta.vue?vue&type=script&lang=js"
import style0 from "./MensagemAlerta.vue?vue&type=style&index=0&id=740e6f73&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e6f73",
  null
  
)

export default component.exports